import React, { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter,
  HashRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { RoutesLists } from "./config/routes";
import Layout from "./Components/layout";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StyledEngineProvider } from "@mui/material/styles";
import { useUserInfoStore } from "./store/userinfo";
import { CircularProgress } from "@mui/material";
import axiosInstance from "./config/Axios/axiosInstance";

const queryClient = new QueryClient();

function App() {
  const { setIsLoggedin, isloggedIn, isLoading }: any = useUserInfoStore(
    (state) => state
  );
  const { setIsloading }: any = useUserInfoStore((state) => state);

  const { setUserInfo }: any = useUserInfoStore((state) => state);
  useEffect(() => {
    if (localStorage.getItem("token-student")) {
      setIsLoggedin(true);
      // axiosInstance.get("/getUserProfile").then((res:any) => setUserInfo(res?.result)).catch(err => console.error(err))
    } else {
      setIsLoggedin(false);
    }
  }, []);

  useEffect(() => {
    if (isloggedIn) {
      axiosInstance
        .get("/getUserProfile")
        .then((res: any) => {
          setUserInfo(res?.result);
          // setIsLoggedin(false);
          setIsloading(false);
        })
        .catch((err) => {
          console.error(err);
          setIsloading(false);
        });
    }
  }, [isloggedIn]);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App overflow-x-hidden">
        {isLoading && (
          <div className="absolute flex bg-[#00000040]  items-center justify-center w-screen h-screen z-[999]">
            <CircularProgress className="!text-white" />
          </div>
        )}
        <StyledEngineProvider injectFirst>
          <HashRouter>
            {/* <BrowserRouter
            basename={
              process.env.PUBLIC_URL ||
              "https://www.techugoapps.com/sygnific_dev"
            }
          > */}
            <Routes>
              {RoutesLists.map(
                ({
                  path,
                  Element,
                  isFooter = true,
                  isHeader = true,
                  isPrivate = false,
                }) => {
                  return (
                    <Route
                      path={path}
                      element={
                        <Layout isFooter={isFooter} isHeader={isHeader}>
                          {(isPrivate && isloggedIn) || !isPrivate ? (
                            <Element />
                          ) : (
                            <Navigate to="/login-signup/login" />
                          )}
                        </Layout>
                      }
                    />
                  );
                }
              )}
            </Routes>
            {/* </BrowserRouter> */}
          </HashRouter>
        </StyledEngineProvider>
      </div>
    </QueryClientProvider>
  );
}

export default App;
